/* eslint-disable react-hooks/rules-of-hooks */

import { Spinner } from '@heroui/spinner'
import { createFileRoute } from '@tanstack/react-router'
import { BanIcon } from 'lucide-react'

import { verificationControllerFindVerificatonsByToken } from '@/api/verification/verification'
import { localStorageKeys } from '@/app/config/consts'
import { StatusVerificationView } from '@/features/verification/status-redirect'
import { useI18nContext } from '@/shared/i18n'
import { getErrorMessage } from '@/shared/lib/axios'
import { FullPageWrapper } from '@/shared/ui'

export const Route = createFileRoute('/_public-links/verification/$id')({
  component: RouteComponent,
  loader: async ({ params: { id } }) => {
    const data = await verificationControllerFindVerificatonsByToken({
      headers: {
        'x-user-client-token': id,
      },
    })

    const formId = data?.verification?.formId
    const verificationId = data?.verification?.id

    if (!formId && !verificationId)
      throw new Error('Form or Verification ID not found, redirecting to form page')

    localStorage.setItem(
      localStorageKeys.verificationId(verificationId),
      JSON.stringify({
        verificationId,
        xUserClientToken: id,
        timestamp: Date.now(),
      }),
    )

    return { formId, verificationId }
  },
  errorComponent: ({ error }) => {
    const { LL } = useI18nContext()
    const errMsg = getErrorMessage(error)

    return (
      <FullPageWrapper>
        <div className="flex w-full flex-col items-center justify-center">
          <h4 className="mt-4 flex items-center">
            {LL.verification.error()}
            <BanIcon className="ml-3 text-3xl font-extrabold text-danger" />
          </h4>
          <p className="text-danger">{errMsg}</p>
        </div>
      </FullPageWrapper>
    )
  },
  pendingComponent: () => {
    const { LL } = useI18nContext()

    return (
      <FullPageWrapper>
        <div className="flex w-full flex-col items-center justify-center">
          <h4 className="mt-4">{LL.verification.loading()}</h4>
          <Spinner size="lg" />
        </div>
      </FullPageWrapper>
    )
  },
})

export const VerificationPublicLink = Route

function RouteComponent() {
  return (
    <FullPageWrapper>
      <StatusVerificationView />
    </FullPageWrapper>
  )
}
